<div *ngIf="dashboard" class="dashboard">
  <div class="dashboard--item">
    <div class="dashboard--item--title">
      <span class="dashboard--item--title--content">Versements</span>
    </div>
    <ng-container *ngFor="let deposit of dashboard?.deposits">
      <div class="dashboard--item--line" [attr.data-cy]="'dashboard-deposit-preview-' + deposit.id">
        <span class="dashboard--item--line--content">
          <span class="dashboard--item--line--content-col">
            {{ deposit.dt_created | date : 'dd/MM/yyyy' }}
          </span>
          <span class="dashboard--item--line--content-col">
            {{ deposit.last_name }}&nbsp;{{ deposit.first_name }}
          </span>
          <span class="dashboard--item--line--content-col">
            {{ deposit.dir_cmp_acronym }}
          </span>
        </span>
        <span class="dashboard--item--title--action" matTooltip="Cliquer pour voir ce dépôt" [routerLink]="['/versement/consultation/', deposit.id]">
          <mat-icon>visibility</mat-icon>
        </span>
      </div>
    </ng-container>
  </div>
  <div class="dashboard--item">
    <div class="dashboard--item--title">
      <span class="dashboard--item--title--content">Bordereaux d'élimination</span>
    </div>
    <ng-container *ngFor="let bel of dashboard?.bels">
      <div class="dashboard--item--line">
        <span class="dashboard--item--line--content">
          <span class="dashboard--item--line--content-col">
            {{ bel.dt_created | date : 'dd/MM/yyyy' }}
          </span>
          <span class="dashboard--item--line--content-col">
            {{ (bel.reference?bel.reference:'pas de référence') }}
          </span>
          <span class="dashboard--item--line--content-col">
            {{ bel.label }}
          </span>
        </span>
        <span class="dashboard--item--title--action" matTooltip="Cliquer pour voir ce bel" [routerLink]="['/elimination/edition-bordereau/', bel.id]">
          <mat-icon>visibility</mat-icon>
        </span>
      </div>
    </ng-container>
  </div>
  <div class="dashboard--item">
    <div class="dashboard--item--title">
      <span class="dashboard--item--title--content">Métrage linéaire</span>
    </div>
    <div class="dashboard--item--line">
      <span class="dashboard--item--line--content">
        <span class="dashboard--item--line--content-col">Total</span>
        <span class="dashboard--item--line--content-col">Libre</span>
        <span class="dashboard--item--line--content-col">Occupé</span>
      </span>
    </div>
    <div class="dashboard--item--line" data-cy="dashboard-ml-detail">
      <span class="dashboard--item--line--content">
        <span class="dashboard--item--line--content-col">{{ dashboard.mls.ml_total }} m.</span>
        <span class="dashboard--item--line--content-col">{{ dashboardSvc.metrageLibreAll(dashboard.mls) }} m.</span>
        <span class="dashboard--item--line--content-col">{{ dashboardSvc.metrageOccupeAll(dashboard.mls) }} m.</span>
      </span>
    </div>
    <div class="dashboard--item--line">
      <span class="dashboard--item--line--content">
        <span class="dashboard--item--line--content-col"></span>
      </span>
    </div>
    <div class="dashboard--item--line">
      <span class="dashboard--item--line--content">
        <span class="dashboard--item--line--content-col"></span>
      </span>
    </div>
    <div class="dashboard--item--line">
      <span class="dashboard--item--line--content">
        <span class="dashboard--item--line--content-col">
          Afficher le détail par magasin
        </span>
      </span>
      <span (click)="magDetail()" class="dashboard--item--title--action" matTooltip="Cliquer pour voir tous les magasins">
          <mat-icon>visibility</mat-icon>
        </span>
    </div>
  </div>
</div>
